import React from 'react'
import { 
  Box, 
  Typography, 
  useTheme, 
  Button, 
  Grid, 
  Chip, 
  Modal, 
  TextField,
  Snackbar,
  IconButton,
  Tooltip,
  CircularProgress,
  Divider,
  Backdrop,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton,
  Avatar
} from "@mui/material";
import { tokens } from "../theme";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { useState, useContext, useEffect } from "react";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import AuthContext from "../auth/AuthProvider";
import { Topbar } from '../layouts/Topbar';
import Sidebarr from '../layouts/Sidebar';
import Header from "../components/Header";
import { useLocation, useNavigate } from 'react-router-dom';
import {api} from "../api";
import { fetchToken } from '../auth/Token';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import { BorderStyle, MonochromePhotosOutlined } from '@mui/icons-material';
import PeopleIcon from '@mui/icons-material/People';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import Chart from "react-apexcharts";
import { toast } from 'sonner';
import { AccountReconciliation } from './KindAccount';
import ArrowRightAltRoundedIcon from '@mui/icons-material/ArrowRightAltRounded';

const AgePieChart = ({males, females, not_specified}) => {
  const config = {
      options: {
        title: {
          text: 'Gender Ratio',
          align: 'left'
        },
        labels: ['Males', 'Females', 'Not specified'],
      },
      series: [males, females, not_specified],
      responsive: [{
        breakpoint: 880,
        options: {
          legend: {
            position: 'bottom'
          }
        }
      }]
      
    };
  return <Chart
              options={config.options}
              series={config.series}
              type="pie"
              height={450}
              width={450}
          />
}

const GenderPieChart = ({youths, middle_aged, old_aged, not_specified}) => {
  const config = {
      options: {
        title: {
          text: 'Age Ratio',
          align: 'left'
        },
        labels: ['Youths', 'Middle Aged', 'Old Aged', 'Not specified'],
      },
      series: [youths, middle_aged, old_aged, not_specified],
      responsive: [{
        breakpoint: 880,
        options: {
          legend: {
            position: 'bottom'
          }
        }
      }]
      
    };
  return <Chart
              options={config.options}
              series={config.series}
              type="pie"
              height={450}
              width={450}
          />
}

const TownPieChart = ({rural, urban, not_specified}) => {
  const config = {
      options: {
        title: {
          text: 'Town Type',
          align: 'left'
        },
        labels: ['Rural Farmers', 'Urban Farmers', 'Not specified'],
      },
      series: [rural, urban, not_specified],
      responsive: [{
        breakpoint: 880,
        options: {
          legend: {
            position: 'bottom'
          }
        }
      }]
      
    };
  return <Chart
              options={config.options}
              series={config.series}
              type="pie"
              height={450}
              width={450}
          />
}

const BarGuy = ({
    m_savings,
    f_savings,
    n_savings,
    m_loans,
    f_loans,
    n_loans,
    m_productionLoans,
    f_productionLoans,
    n_productionLoans,
    m_equipmentLoans,
    f_equipmentLoans,
    n_equipmentLoans,
    m_commodityLoans,
    f_commodityLoans,
    n_commodityLoans,
    m_shares,
    f_shares,
    n_shares,
}) => {

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });

  const config = {
    series: [{
      name: 'Males',
      data: [m_savings, m_loans, m_productionLoans, m_equipmentLoans, m_commodityLoans, m_shares]
    }, {
      name: 'Females',
      data: [f_savings, f_loans, f_productionLoans, f_equipmentLoans, f_commodityLoans, f_shares]
    }, {
      name: 'Not Specified',
      data: [n_savings, n_loans, n_productionLoans, n_equipmentLoans, n_commodityLoans, n_shares]
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Savings', 'Cash Loans', 'Production Loans', 'Equipment Loans', 'Commodity Loans', 'Shares'],
      },
      yaxis: {
        title: {
          text: 'Balances'
        },
        labels: {
          show: true,
          formatter: function (val) {
            return currencyFormat.format(val)
          }
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return currencyFormat.format(val)
          }
        }
      },
      title: {
        text: 'Gender Performances',
        style: {
          color: '#444',
          fontFamily: "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        }
      }
    },
  }

  return <Chart 
            options={config.options}
            series={config.series}
            type="bar"
            height={360}
        />
}

const BarGuyExpense = ({expense_account}) => {

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });

  const config = {
    series: [{
      name: 'Amount spent',
      data: expense_account?.map((one) => one.current_balance)
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: expense_account?.map((one) => one.account_name),
      },
      yaxis: {
        title: {
          text: 'Amount spent'
        },
        labels: {
          show: true,
          formatter: function (val) {
            return currencyFormat.format(val)
          }
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return currencyFormat.format(val)
          }
        }
      },
      title: {
        text: 'Expenditures',
        style: {
          color: '#444',
          fontFamily: "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        }
      }
    },
  }

  return <Chart 
            options={config.options}
            series={config.series}
            type="bar"
            height={360}
      />
}

const BarGuyTown = ({
    r_savings,
    u_savings,
    ntt_savings,
    r_loans,
    u_loans,
    ntt_loans,
    r_productionLoans,
    u_productionLoans,
    ntt_productionLoans,
    r_equipmentLoans,
    u_equipmentLoans,
    ntt_equipmentLoans,
    r_commodityLoans,
    u_commodityLoans,
    ntt_commodityLoans,
    r_shares,
    u_shares,
    ntt_shares,
  }) => {

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });

  const config = {
    series: [{
      name: 'Rural Farmers',
      data: [r_savings, r_loans, r_productionLoans, r_equipmentLoans, r_commodityLoans, r_shares]
    }, {
      name: 'Urban Farmers',
      data: [u_savings, u_loans, u_productionLoans, u_equipmentLoans, u_commodityLoans, u_shares]
    }, {
      name: 'Not Specified',
      data: [ntt_savings, ntt_loans, ntt_productionLoans, ntt_equipmentLoans, ntt_commodityLoans, ntt_shares]
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Savings', 'Cash Loans', 'Production Loans', 'Equipment Loans', 'Commodity Loans', 'Shares'],
      },
      yaxis: {
        title: {
          text: 'Balances'
        },
        labels: {
          show: true,
          formatter: function (val) {
            return currencyFormat.format(val)
          }
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return currencyFormat.format(val)
          }
        }
      },
      title: {
        text: 'Area Type Performances',
        style: {
          color: '#444',
          fontFamily: "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        }
      }
    },
  }

  return <Chart 
            options={config.options}
            series={config.series}
            type="bar"
            height={360}
      />
}

const BarGuyAge = ({
    y_savings,
    ma_savings,
    oa_savings,
    na_savings,
    y_loans,
    ma_loans,
    oa_loans,
    na_loans,
    y_productionLoans,
    ma_productionLoans,
    oa_productionLoans,
    na_productionLoans,
    y_equipmentLoans,
    ma_equipmentLoans,
    oa_equipmentLoans,
    na_equipmentLoans,
    y_commodityLoans,
    ma_commodityLoans,
    oa_commodityLoans,
    na_commodityLoans,
    y_shares,
    ma_shares,
    oa_shares,
    na_shares,
  }) => {

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });

  const config = {
    series: [{
      name: 'Youths',
      data: [y_savings, y_loans, y_productionLoans, y_equipmentLoans, y_commodityLoans, y_shares]
    }, {
      name: 'Middle Aged',
      data: [ma_savings, ma_loans, ma_productionLoans, ma_equipmentLoans, ma_commodityLoans, ma_shares]
    },{
      name: 'Old Aged',
      data: [oa_savings, oa_loans, oa_productionLoans, oa_equipmentLoans, oa_commodityLoans, oa_shares]
    }, {
      name: 'Not Specified',
      data: [na_savings, na_loans, na_productionLoans, na_equipmentLoans, na_commodityLoans, na_shares]
    }],
    options: {
      chart: {
        type: 'bar',
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Savings', 'Cash Loans', 'Production Loans', 'Equipment Loans', 'Commodity Loans', 'Shares'],
      },
      yaxis: {
        title: {
          text: 'Balances'
        },
        labels: {
          show: true,
          formatter: function (val) {
            return currencyFormat.format(val)
          }
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return currencyFormat.format(val)
          }
        }
      },
      title: {
        text: 'Age Cat. Performances',
        style: {
          color: '#444',
          fontFamily: "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        }
      }
    },
  }

  return <Chart 
            options={config.options}
            series={config.series}
            type="bar"
            height={460}
            width={880}
        />
}

const LandDonuts = ({land_details}) => {
  const config = {
      options: {
        title: {
          text: 'Farm Lands',
          align: 'left'
        },
        labels: land_details?.pie_data?.map(one => one.Crop),
        fill: {
          type: 'gradient',
        },
      },
      series: land_details?.pie_data?.map(one => one.land_size),
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
      
    };
  return <Chart
              options={config.options}
              series={config.series}
              type="donut"
              height={450}
              width={450}
          />
}

const AreaManProduction = ({land_details}) => {

  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });


  const config = {
    series: land_details?.production_data[0]?.crop?.map(land => ({
      name: land.crop,
      data: land?.bags?.map(two => two?.bags)
    })),
    options: {
      chart: {
        height: 350,
        type: 'area'
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      xaxis: {
        type: 'String',
        categories: land_details?.production_data[0]?.seasons.map(land => land?.season),
      },
      title: {
        text: 'Seasons and bags produced',
        style: {
          color: '#444',
          fontFamily: "'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif",
        }
      }
    },
  }

  return <Chart 
            options={config.options}
            series={config.series}
            type="area"
            height={360}
      />
}


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: 'groove',
  border: '3px',
  borderColor:'grey',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
  marginTop: '10px',
  minHeight:'50px',
  borderRadius:'10px'
}));



export const SocietyDash = ({ society_id, isOnline }) => {
    const [members, setMembers] = useState([]);
    const [society, setSociety] = useState([]);
    const [expense_account, setExpense_account] = useState([]);
    const [communities, setCommunities] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
    const [associations, setAssociations] = useState([]);
    const [farmers_details, setFarmers_details] = useState();
    const [all_details, setAll_details] = useState();
    const [no_details, setNo_details] = useState();
    const [all_land_details, setAll_land_details] = useState();
    const [land_details, setLand_details] = useState();
    const [no_land_details, setNo_land_details] = useState();
    const navigate = useNavigate();
    const [allowed, setAllowed] = useState();
    const [momo, setMomo] = useState();
    const [value, setValue] = React.useState('1');
    const [value1, setValue1] = React.useState('1');
    const [value2, setValue2] = React.useState('1');
    const [value3, setValue3] = React.useState('1');
    const [cash, setCash] = useState();
    const [me, setMe] = useState([]);


    const handleAccountsDashNav = () => {
      navigate('/financial-statements', {
        state: {
          society_name: society.society,
          society_id: society_id
        }
      });
    }


    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
    const handleChange1 = (event, newValue) => {
      setValue1(newValue);
    };
    const handleChange2 = (event, newValue) => {
      setValue2(newValue);
    };
    const handleChange3 = (event, newValue) => {
      setValue3(newValue);
    };


    const visitAccount = () => {
      navigate('/accounts/society', {state: {society_id: society.id, name: society.society } });
    }

    const getInitials = (crop) => {
      const firstInitial = crop ? crop.charAt(0).toUpperCase() : '';
      const lastInitial = crop ? crop.charAt(1).toUpperCase() : '';
      return `${firstInitial}${lastInitial}`;
    };

    const goThere = () => {
      if(allowed === 0 || allowed === society.id){
        navigate(`/allassociationKind/${society.id}`)
      }else{
        toast.error('Not Allowed')
      }
    }

    const currencyFormat = new Intl.NumberFormat('en-GH', {
      style: 'currency',
      currency: 'GHS',
    });

    

    const fetch_data = () => {
      const storedData = localStorage.getItem(`society_${society_id}`);
    
      if (!isOnline) {
        const data = JSON.parse(storedData);
        setMembers(data.members);
        setSociety(data.society);
        setCommunities(data.communities);
        setAssociations(data.associations);
        setWarehouses(data.warehouses);
        setAllowed(data.allowed);
        setMomo(data.momo);
        setExpense_account(data.expense_account);
        setCash(data.cash);
        setFarmers_details(data.farmers_details);
        setLand_details(data.land_details);
        setAll_details(data.all_details);
        setAll_land_details(data.all_land_details);
        setNo_details(data.no_details);
        setNo_land_details(data.no_land_details);
        setMe(data.me);
        return; // Skip fetching if data is already in localStorage
      }
    
      const new_data = {};
    
      // Request dashboards details
      api.get(`/dashboards/details/for/society/dash/${society_id}`, {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setMembers(response.data?.data[0]);
          setSociety(response.data?.society);
          setCommunities(response.data?.communities);
          setAssociations(response.data?.associations);
          setWarehouses(response.data?.warehouses);
    
          new_data.members = response.data?.data[0];
          new_data.society = response.data?.society;
          new_data.communities = response.data?.communities;
          new_data.associations = response.data?.associations;
          new_data.warehouses = response.data?.warehouses;
        })
        .catch((error) => console.log(error));
    
      // Request allowed
      api.get('/users/user/society', {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setAllowed(response.data?.Soc);
          new_data.allowed = response.data?.Soc;
        })
        .catch((error) => console.log(error));
    
      // Momo details
      api.get(`/association/society/momo/${society_id}`, {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setMomo(response.data?.data);
          new_data.momo = response.data?.data;
        })
        .catch((error) => console.log(error));
    
      // Expense account details
      api.get(`/dashboards/analytics/expenditure/${society_id}`, {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setExpense_account(response.data);
          new_data.expense_account = response.data;
        })
        .catch((error) => console.log(error));
    
      // Cash details
      const sendData = new FormData();
      sendData.append('society_id', society_id);
      sendData.append('start_date', '');
      sendData.append('end_date', '');
      api.post('/association/cash/society/data', sendData, {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setCash(response.data);
          new_data.cash = response.data;
        })
        .catch((error) => console.log(error));
    
      // Farmers details
      api.get(`/dashboards/farmers/analytics/society/dash/${society_id}`, {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setFarmers_details(response.data);
          new_data.farmers_details = response.data;
        })
        .catch((error) => console.log(error));
    
      // Farmers trade data
      api.get(`/dashboards/farmers/analytics/society/dash/trade/data/${society_id}`, {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setLand_details(response.data);
          new_data.land_details = response.data;
        })
        .catch((error) => console.log(error));
    
      // All details
      api.get(`/dashboards/all/analytics/society/dash/${society_id}`, {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setAll_details(response.data);
          new_data.all_details = response.data;
        })
        .catch((error) => console.log(error));
    
      // All land details
      api.get(`/dashboards/all/analytics/society/dash/trade/data/${society_id}`, {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setAll_land_details(response.data);
          new_data.all_land_details = response.data;
        })
        .catch((error) => console.log(error));
    
      // No farmers details
      api.get(`/dashboards/non_farmers/analytics/society/dash/${society_id}`, {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setNo_details(response.data);
          new_data.no_details = response.data;
        })
        .catch((error) => console.log(error));
    
      // No land details
      api.get(`/dashboards/non_farmers/analytics/society/dash/trade/data/${society_id}`, {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setNo_land_details(response.data);
          new_data.no_land_details = response.data;
        })
        .catch((error) => console.log(error));
    
      // Me details
      api.get('/users/su', {
        headers: { Authorization: 'Bearer ' + fetchToken() }
      })
        .then((response) => {
          setMe(response.data);
          new_data.me = response.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {
          localStorage.setItem(`society_${society_id}`, JSON.stringify(new_data));
        });
    };
    
    useEffect(() => {
      fetch_data();
    }, [society_id]);
    
    // console.log(me)

    if(society){
      return(
        <Grid item xs={12} md={12}>
          <Typography sx={{ texAlign:'center' }} variant='h4' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            <b>{society.society}</b>  
          </Typography>


          <Grid container spacing={2}>
            {
              me?.role_name === 'Supervisors'?
                <Grid item xs={12} md={12}>
                  <AccountReconciliation id={society.id} name={society.society} dash={true}/>
                </Grid>
              :null
            }
            

            <Grid item xs={12} md={3}>
              {
                me?.role_name === 'Administrator'?
                  <Box
                    onClick={handleAccountsDashNav}
                  >
                    <Item>
                      <div
                        style={{
                          display:'flex',
                          justifyContent:'space-between',
                          cursor:'pointer'
                        }}
                      >
                        <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>View Financial Reports</b>  
                        </Typography> 
                        <Typography>
                          <ArrowRightAltRoundedIcon />
                        </Typography>
                      </div>
                    </Item>
                  </Box>
                :null
              }
              

              <Item>

                <Grid container spacing={2}>

                  <Grid item xs={12} md={12}>
                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                      <b>Members</b>  
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={12} sx={{ display:'flex', flexDirection:'row' }}>
                      <Typography sx={{ margin:'auto', color:'#2b2d42' }} variant='h3' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b style={{ marginRight: '5px' }}>{members.members}</b>
                        {members.members_this_month > 0 ? (<TrendingUpIcon color="success"/>) : null}
                      </Typography>
                  </Grid>

                  <Grid item xs={12} md={12}>
                      <Typography sx={{ margin:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>{members.farmers} out of {members.members} are farmers</b>  
                      </Typography>
                  </Grid>

                  <Grid item xs={12} md={12}>
                      <Typography color={members.members_this_month > 0 ?'success': 'primary'} sx={{ margin:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b> +{members.members_this_month} this month</b>  
                      </Typography>
                  </Grid>
                </Grid>
              </Item>
              {
                me?.role_name !== 'Supervisors' || me?.role_name !== 'Senior Facilitator'?
                <>
                  <Item>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Momo (real time ecash balance)</b>  
                        </Typography>
                      </Grid>

                      <Grid container xs={12} md={12} sx={{ display:'flex', flexDirection:'row' }}>
                          <Typography sx={{ margin:'auto', color:'#2b2d42' }} variant='h3' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b style={{ marginRight: '5px' }}>{currencyFormat.format(momo?.current_balance?momo?.current_balance:0)}</b>
                            {/* {members.members_this_month > 0 ? (<TrendingUpIcon color="success"/>) : null} */}
                            <IconButton onClick={visitAccount}><ViewAgendaIcon /></IconButton>
                          </Typography>
                      </Grid>
                    </Grid>
                  </Item>

                  <Item>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12}>
                        <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Society's Worth</b>  
                        </Typography>
                      </Grid>

                      <Grid container xs={12} md={12} sx={{ display:'flex', flexDirection:'row' }}>
                          <Typography sx={{ margin:'auto', color:'#2b2d42' }} variant='h3' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b style={{ marginRight: '5px' }}>{currencyFormat.format(cash?.society_worth?cash?.society_worth:0)}</b>
                              {cash?.all_credits > cash?.all_debits ? (<TrendingUpIcon color="success"/>) :cash?.all_credits < cash?.all_debits? (<TrendingDownIcon color="error"/>) : (<TrendingFlatIcon color="primary"/>)}
                          </Typography>
                      </Grid>
                      <Grid container xs={12} md={12} sx={{ display:'flex', flexDirection:'row' }}>
                          <Typography sx={{ ml:2 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b style={{ marginRight: '5px' }}>Credits: {currencyFormat.format(cash?.all_credits?cash?.all_credits:0)}</b>
                          </Typography>
                      </Grid>
                      <Grid container xs={12} md={12} sx={{ display:'flex', flexDirection:'row' }}>
                          <Typography sx={{ ml:2 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b style={{ marginRight: '5px' }}>Debits: {currencyFormat.format(cash?.all_debits?cash?.all_debits:0)}</b>
                          </Typography>
                      </Grid>
                    </Grid>
                  </Item>
                </>
                :null
              }
              

              
            </Grid>

            <Grid item xs={12} md={3}>
              <Item>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Box sx={{ display:'flex', flexDirection:'row' }}>
                        <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Communities</b>  
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>Total: {members.communities}</b>  
                        </Typography>
                    </Box>
                    <Divider variant='middle'/>
                  </Grid>

                  <Grid item xs={12} md={12}>
                  {
                    communities[0]?
                      <List 
                        sx={{ 
                          maxHeight: "40vh", 
                          overflow:'auto',
                          '&::-webkit-scrollbar': {
                            width: '4px',
                          },
                          '&::-webkit-scrollbar-track': {
                              background: '#f1f1f1',
                          },
                          '&::-webkit-scrollbar-thumb': {
                              background: '#888',
                              borderRadius: '10px',
                          },
                          '&::-webkit-scrollbar-thumb:hover': {
                              background: '#555',
                          } 
                        }}
                      >
                        {
                          communities.map((two) => (
                            <>
                              <ListItemButton sx={{ m:0, p:0 }}>
                                <ListItem
                                  alignItems="flex-start"
                                  secondaryAction={
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>{two.members_count} members</b>  
                                    </Typography>
                                    }>
                                  <ListItemAvatar>
                                    <Avatar
                                      sx={{ width: 55, height: 55, mr:1, backgroundColor:'#144552' }}
                                    >
                                      {getInitials(two.community)}
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText
                                    primary={two.community}
                                    secondary={
                                      <Box sx={{ display:'block' }}>
                                      <div>
                                        <Typography
                                          sx={{ display: 'inline' }}
                                          component="span"
                                          variant="body2"
                                          color="text.primary"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>{two.association_count} savings group</b>
                                        </Typography>
                                      </div>
                                        <div>
                                          <Typography
                                            sx={{ display: 'inline' }}
                                            variant="body2"
                                            color="text.primary"
                                          >
                                            <b>{two.farmers_count} farmers</b>
                                          </Typography>
                                        </div>
                                        
                                      </Box>
                                    }
                                  />
                                </ListItem>
                              </ListItemButton>
                              <Divider variant="inset" component="li" />
                            </>
                          ))
                        }
                      </List>
                      :
                      <Box sx={{ margin:'auto' }}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b style={{ mr:'10px' }}>No communities in this Society</b> 
                            <Button
                              size='small'
                              variant='contained'
                              sx={{ 
                                borderRadius:'10px',
                                backgroundColor:'#2b2d42',
                                color:'#fff',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                              }}
                              onClick={goThere}
                            >
                              Build Community  
                            </Button> 
                          </Typography>
                      </Box>
                  }
                  
                  </Grid>
                </Grid>
              </Item>
            </Grid>

            <Grid item xs={12} md={2}>
              <Item>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Box sx={{ display:'flex', flexDirection:'row' }}>
                      <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Savings Groups</b>  
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Total: {members.associations}</b>  
                      </Typography>
                  </Box>
                  <Divider variant='middle'/>
                </Grid>
                
                {
                    members.associations > 0?

                    <Grid item xs={12} md={12}>
                        <List 
                          sx={{ 
                            maxHeight: "40vh", 
                            overflow:'auto',
                            '&::-webkit-scrollbar': {
                              width: '4px',
                              height:'4px'
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            } 
                          }}
                        >
                          {
                            associations.map((three) => (
                              <>
                                <ListItemButton sx={{ m:0, p:0 }}>
                                  <ListItem
                                    alignItems="flex-start"
                                    >
                                    <ListItemAvatar>
                                      <Avatar
                                        sx={{ width: 55, height: 55, mr:1, backgroundColor:'#144552' }}
                                      >
                                        {getInitials(three.association)}
                                      </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={three.association}
                                      secondary={
                                        <Box sx={{ display:'block' }}>
                                        <div>
                                          <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{three.members_count} members</b>
                                          </Typography>
                                        </div>
                                        <div>
                                          <Typography
                                            sx={{ display: 'inline' }}
                                            variant="body2"
                                            color="text.primary"
                                          >
                                            <b>{three.farmers_count} farmers</b>
                                          </Typography>
                                        </div>
                                          
                                        </Box>
                                      }
                                    />
                                  </ListItem>
                                </ListItemButton>
                                <Divider variant="inset" component="li" />
                              </>
                            ))
                          }
                        </List>
                    </Grid>
                      :
                      <Grid item xs={12} md={12}>
                        <Box sx={{ margin:'auto' }}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b style={{ mr:'10px' }}>No Savings Groups in this Society</b>
                          </Typography>
                        </Box>
                      </Grid>
                  }
              </Grid>
              </Item>
            </Grid>
                  {/* Warehouses */}
            <Grid item xs={12} md={4}>
              <Item>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Box sx={{ display:'flex', flexDirection:'row' }}>
                      <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Warehouses</b>  
                      </Typography>
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Total: {members.warehouses}</b>  
                      </Typography>
                  </Box>
                  <Divider variant='middle'/>
                </Grid>
                
                {
                    members.warehouses > 0?

                    <Grid item xs={12} md={12}>
                        <List 
                          sx={{ 
                            maxHeight: "40vh", 
                            overflow:'auto',
                            '&::-webkit-scrollbar': {
                              width: '4px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            } 
                          }}
                        >
                          {
                            warehouses.map((three) => (
                              <>
                                <ListItemButton sx={{ m:0, p:0 }}>
                                  <ListItem
                                    alignItems="flex-start"
                                    secondaryAction={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>{three.associations} savings group</b>  
                                      </Typography>
                                      }
                                    >
                                    <ListItemAvatar>
                                      <Avatar
                                        sx={{ width: 55, height: 55, mr:1, backgroundColor:'#144552' }}
                                      >
                                        {getInitials(three.warehouse_name)}
                                      </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={three.warehouse_name}
                                      secondary={
                                        <Box sx={{ display:'block' }}>
                                        <div>
                                          <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                          >
                                            <b>{three.members} members</b>
                                          </Typography>
                                        </div>
                                        <div>
                                          <Typography
                                            sx={{ display: 'inline' }}
                                            variant="body2"
                                            color="text.primary"
                                          >
                                            <b>{three.bags} bags</b>
                                          </Typography>
                                        </div>
                                          
                                        </Box>
                                      }
                                    />
                                  </ListItem>
                                </ListItemButton>
                                <Divider variant="inset" component="li" />
                              </>
                            ))
                          }
                        </List>
                    </Grid>
                      :
                      <Grid item xs={12} md={12}>
                        <Box sx={{ margin:'auto' }}>
                          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b style={{ mr:'10px' }}>No Warehouse in this Society</b>
                          </Typography>
                        </Box>
                      </Grid>
                  }
              </Grid>
              </Item>
            </Grid>

            

            <Grid item xs={12} md={12}>
              <Item>
                <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <TabContext  value={value1}>
                    <TabList onChange={handleChange1} sx={{ 
                          m: 'auto',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          backgroundColor: '#ffffff',
                          borderWidth: 2,
                          borderRadius: 4,
                          p: 0,
                          maxWidth: '100%',
                          alignItems: 'center',
                        }} aria-label="lab API tabs example">
                      <Tab sx={{
                          pt: 0,
                          pb: 0,
                          pr: 1, 
                          pl: 1,
                          backgroundColor: '#ffffff',
                          borderRadius: 4,
                          borderWidth:'2px',
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                          m:'8px'
                        }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>All</b></Typography>} value="1" />
                      <Tab sx={{
                          pt: 0,
                          pb: 0,
                          pr: 1, 
                          pl: 1,
                          backgroundColor: '#ffffff',
                          borderRadius: 4,
                          borderWidth:'2px',
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                          m:'8px',
                          mr:'5px'
                        }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Members</b></Typography>} value="2" />
                      <Tab sx={{
                          pt: 0,
                          pb: 0,
                          pr: 1, 
                          pl: 1,
                          backgroundColor: '#ffffff',
                          borderRadius: 4,
                          borderWidth:'2px',
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                          m:'8px',
                          mr:'5px'
                        }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Farmers</b></Typography>} value="3" />
                    </TabList>
                    
                    <TabPanel value="1">
                    <Grid container spacing={2}>
                          <Grid item xs={12} md={12}>
                            <Box sx={{ display:'flex', flexDirection:'row' }}>
                              <Typography sx={{ marginRight:'auto' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>All Members</b>  
                              </Typography>
                              <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total: {members.members}</b>  
                              </Typography>
                            </Box>
                            <Divider variant='middle'/>
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TabContext  value={value2}>
                                <TabList onChange={handleChange2} sx={{ 
                                      m: 'auto',
                                      display: 'flex',
                                      flexDirection: 'row',
                                      justifyContent: 'center',
                                      backgroundColor: '#ffffff',
                                      borderWidth: 2,
                                      borderRadius: 4,
                                      p: 0,
                                      maxWidth: '100%',
                                      alignItems: 'center',
                                    }} aria-label="lab API tabs example">
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Gender Ratio</b></Typography>} value="1" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Age Ratio</b></Typography>} value="2" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px',
                                      mr:'5px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Town Type</b></Typography>} value="3" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px',
                                      mr:'5px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Farm Lands</b></Typography>} value="4" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px',
                                      mr:'5px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Production Data</b></Typography>} value="5" />
                                </TabList>
                                {/* Gender ratio */}
                              <TabPanel value="1">
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Males: {all_details?.males_count?all_details?.males_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Females: {all_details?.females_count?all_details?.females_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Not Specified: {all_details?.no_gender_count?all_details?.no_gender_count:0}</b>  
                                      </Typography>

                                      <AgePieChart 
                                        males={all_details?.males_count?all_details?.males_count:0} 
                                        females={all_details?.females_count?all_details?.females_count:0} 
                                        not_specified={all_details?.no_gender_count?all_details?.no_gender_count:0}
                                      />
                                  </Grid>

                                  <Grid item xs={12} md={8}>
                                    <BarGuy 
                                      m_savings={all_details?.m_savings}
                                      f_savings={all_details?.f_savings}
                                      n_savings={all_details?.n_savings}
                                      m_loans={all_details?.m_loans}
                                      f_loans={all_details?.f_loans}
                                      n_loans={all_details?.n_loans}
                                      m_productionLoans={all_details?.m_productionLoans}
                                      f_productionLoans={all_details?.f_productionLoans}
                                      n_productionLoans={all_details?.n_productionLoans}
                                      m_equipmentLoans={all_details?.m_equipmentLoans}
                                      f_equipmentLoans={all_details?.f_equipmentLoans}
                                      n_equipmentLoans={all_details?.n_equipmentLoans}
                                      m_commodityLoans={all_details?.m_commodityLoans}
                                      f_commodityLoans={all_details?.f_commodityLoans}
                                      n_commodityLoans={all_details?.n_commodityLoans}
                                      m_shares={all_details?.m_shares}
                                      f_shares={all_details?.f_shares}
                                      n_shares={all_details?.n_shares}
                                    />
                                  </Grid>

                                </Grid>
                                
                              </TabPanel>
                              <TabPanel value="2">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                      <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Youths (15 to 39): {all_details?.youth_count?all_details?.youth_count:0}</b>  
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Middle-Aged (40 to 60): {all_details?.middle_age_count?all_details?.middle_age_count:0}</b>  
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Old-Aged (60...): {all_details?.old_age_count?all_details?.old_age_count:0}</b>  
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Not Specified: {all_details?.no_age_count?all_details?.no_age_count:0}</b>  
                                        </Typography>

                                        <GenderPieChart 
                                          youths={all_details?.youth_count?all_details?.youth_count:0} 
                                          middle_aged={all_details?.middle_age_count?all_details?.middle_age_count:0} 
                                          old_aged={all_details?.old_age_count?all_details?.old_age_count:0} 
                                          not_specified={all_details?.no_age_count?all_details?.no_age_count:0}
                                        />
                                    </Grid>
                                  <Grid item xs={12} md={8}>
                                    <BarGuyAge 
                                      y_savings={all_details?.y_savings}
                                      ma_savings={all_details?.ma_savings}
                                      oa_savings={all_details?.oa_savings}
                                      na_savings={all_details?.na_savings}
                                      y_loans={all_details?.y_loans}
                                      ma_loans={all_details?.ma_loans}
                                      oa_loans={all_details?.oa_loans}
                                      na_loans={all_details?.na_loans}
                                      y_productionLoans={all_details?.y_productionLoans}
                                      ma_productionLoans={all_details?.ma_productionLoans}
                                      oa_productionLoans={all_details?.oa_productionLoans}
                                      na_productionLoans={all_details?.na_productionLoans}
                                      y_equipmentLoans={all_details?.y_equipmentLoans}
                                      ma_equipmentLoans={all_details?.ma_equipmentLoans}
                                      oa_equipmentLoans={all_details?.oa_equipmentLoans}
                                      na_equipmentLoans={all_details?.na_equipmentLoans}
                                      y_commodityLoans={all_details?.y_commodityLoans}
                                      ma_commodityLoans={all_details?.ma_commodityLoans}
                                      oa_commodityLoans={all_details?.oa_commodityLoans}
                                      na_commodityLoans={all_details?.na_commodityLoans}
                                      y_shares={all_details?.y_shares}
                                      ma_shares={all_details?.ma_shares}
                                      oa_shares={all_details?.oa_shares}
                                      na_shares={all_details?.na_shares}
                                    />
                                  </Grid>
                                </Grid>
                              </TabPanel>
                              <TabPanel value="3">
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Rural Farmers: {all_details?.rural_count?all_details?.rural_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Urban Farmers: {all_details?.urban_count?all_details?.urban_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Not Specified: {all_details?.no_town_count?all_details?.no_town_count:0}</b>  
                                      </Typography>

                                      <TownPieChart 
                                        rural={all_details?.rural_count?all_details?.rural_count:0} 
                                        urban={all_details?.urban_count?all_details?.urban_count:0} 
                                        not_specified={all_details?.no_town_count?all_details?.no_town_count:0}
                                      />
                                  </Grid>

                                  <Grid item xs={12} md={8}>
                                    <BarGuyTown 
                                      r_savings={all_details?.r_savings}
                                      u_savings={all_details?.u_savings}
                                      ntt_savings={all_details?.ntt_savings}
                                      r_loans={all_details?.r_loans}
                                      u_loans={all_details?.u_loans}
                                      ntt_loans={all_details?.ntt_loans}
                                      r_productionLoans={all_details?.r_productionLoans}
                                      u_productionLoans={all_details?.u_productionLoans}
                                      ntt_productionLoans={all_details?.ntt_productionLoans}
                                      r_equipmentLoans={all_details?.r_equipmentLoans}
                                      u_equipmentLoans={all_details?.u_equipmentLoans}
                                      ntt_equipmentLoans={all_details?.ntt_equipmentLoans}
                                      r_commodityLoans={all_details?.r_commodityLoans}
                                      u_commodityLoans={all_details?.u_commodityLoans}
                                      ntt_commodityLoans={all_details?.ntt_commodityLoans}
                                      r_shares={all_details?.r_shares}
                                      u_shares={all_details?.u_shares}
                                      ntt_shares={all_details?.ntt_shares}
                                    />
                                  </Grid>
                                </Grid>
                              </TabPanel>
                              <TabPanel value="4">
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Crops and total land sizes</b>  
                                    </Typography>
                                    <Divider variant='middle'/>
                                    {
                                      all_land_details?.pie_data.map((one) => (
                                        <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{one.Crop}: {one?.land_size} acres</b>  
                                        </Typography>
                                      ))
                                    }
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Total: {all_land_details?.total_land} acres</b>  
                                    </Typography>
                                  </Grid>
                                  
                                  <Grid item xs={12} md={8}>
                                      <LandDonuts 
                                        land_details={all_land_details}
                                      />
                                  </Grid>
                                </Grid>
                              </TabPanel>
                              <TabPanel value="5">
                                  <Grid item xs={12} md={12}>
                                    <AreaManProduction 
                                      land_details={all_land_details}
                                    />
                                  </Grid>
                              </TabPanel>
                            </TabContext>
                          </Grid>
                        </Grid>
                    </TabPanel>

                    <TabPanel value='2'>
                    <Grid container spacing={2}>
                          <Grid item xs={12} md={12}>
                            <Box sx={{ display:'flex', flexDirection:'row' }}>
                              <Typography sx={{ marginRight:'auto' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Members</b>  
                              </Typography>
                              <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total: {(members.members - members.farmers)}</b>  
                              </Typography>
                            </Box>
                            <Divider variant='middle'/>
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TabContext  value={value3}>
                                <TabList onChange={handleChange3} sx={{ 
                                      m: 'auto',
                                      display: 'flex',
                                      flexDirection: 'row',
                                      justifyContent: 'center',
                                      backgroundColor: '#ffffff',
                                      borderWidth: 2,
                                      borderRadius: 4,
                                      p: 0,
                                      maxWidth: '100%',
                                      alignItems: 'center',
                                    }} aria-label="lab API tabs example">
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Gender Ratio</b></Typography>} value="1" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Age Ratio</b></Typography>} value="2" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px',
                                      mr:'5px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Town Type</b></Typography>} value="3" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px',
                                      mr:'5px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Farm Lands</b></Typography>} value="4" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px',
                                      mr:'5px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Production Data</b></Typography>} value="5" />
                                </TabList>
                                {/* Gender ratio */}
                              <TabPanel value="1">
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Males: {no_details?.males_count?no_details?.males_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Females: {no_details?.females_count?no_details?.females_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Not Specified: {no_details?.no_gender_count?no_details?.no_gender_count:0}</b>  
                                      </Typography>

                                      <AgePieChart 
                                        males={no_details?.males_count?no_details?.males_count:0} 
                                        females={no_details?.females_count?no_details?.females_count:0} 
                                        not_specified={no_details?.no_gender_count?no_details?.no_gender_count:0}
                                      />
                                  </Grid>

                                  <Grid item xs={12} md={8}>
                                    <BarGuy 
                                      m_savings={no_details?.m_savings}
                                      f_savings={no_details?.f_savings}
                                      n_savings={no_details?.n_savings}
                                      m_loans={no_details?.m_loans}
                                      f_loans={no_details?.f_loans}
                                      n_loans={no_details?.n_loans}
                                      m_productionLoans={no_details?.m_productionLoans}
                                      f_productionLoans={no_details?.f_productionLoans}
                                      n_productionLoans={no_details?.n_productionLoans}
                                      m_equipmentLoans={no_details?.m_equipmentLoans}
                                      f_equipmentLoans={no_details?.f_equipmentLoans}
                                      n_equipmentLoans={no_details?.n_equipmentLoans}
                                      m_commodityLoans={no_details?.m_commodityLoans}
                                      f_commodityLoans={no_details?.f_commodityLoans}
                                      n_commodityLoans={no_details?.n_commodityLoans}
                                      m_shares={no_details?.m_shares}
                                      f_shares={no_details?.f_shares}
                                      n_shares={no_details?.n_shares}
                                    />
                                  </Grid>

                                </Grid>
                                
                              </TabPanel>
                              <TabPanel value="2">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                      <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Youths (15 to 39): {no_details?.youth_count?no_details?.youth_count:0}</b>  
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Middle-Aged (40 to 60): {no_details?.middle_age_count?no_details?.middle_age_count:0}</b>  
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Old-Aged (60...): {no_details?.old_age_count?no_details?.old_age_count:0}</b>  
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Not Specified: {no_details?.no_age_count?no_details?.no_age_count:0}</b>  
                                        </Typography>

                                        <GenderPieChart 
                                          youths={no_details?.youth_count?no_details?.youth_count:0} 
                                          middle_aged={no_details?.middle_age_count?no_details?.middle_age_count:0} 
                                          old_aged={no_details?.old_age_count?no_details?.old_age_count:0} 
                                          not_specified={no_details?.no_age_count?no_details?.no_age_count:0}
                                        />
                                    </Grid>
                                  <Grid item xs={12} md={8}>
                                    <BarGuyAge 
                                      y_savings={no_details?.y_savings}
                                      ma_savings={no_details?.ma_savings}
                                      oa_savings={no_details?.oa_savings}
                                      na_savings={no_details?.na_savings}
                                      y_loans={no_details?.y_loans}
                                      ma_loans={no_details?.ma_loans}
                                      oa_loans={no_details?.oa_loans}
                                      na_loans={no_details?.na_loans}
                                      y_productionLoans={no_details?.y_productionLoans}
                                      ma_productionLoans={no_details?.ma_productionLoans}
                                      oa_productionLoans={no_details?.oa_productionLoans}
                                      na_productionLoans={no_details?.na_productionLoans}
                                      y_equipmentLoans={no_details?.y_equipmentLoans}
                                      ma_equipmentLoans={no_details?.ma_equipmentLoans}
                                      oa_equipmentLoans={no_details?.oa_equipmentLoans}
                                      na_equipmentLoans={no_details?.na_equipmentLoans}
                                      y_commodityLoans={no_details?.y_commodityLoans}
                                      ma_commodityLoans={no_details?.ma_commodityLoans}
                                      oa_commodityLoans={no_details?.oa_commodityLoans}
                                      na_commodityLoans={no_details?.na_commodityLoans}
                                      y_shares={no_details?.y_shares}
                                      ma_shares={no_details?.ma_shares}
                                      oa_shares={no_details?.oa_shares}
                                      na_shares={no_details?.na_shares}
                                    />
                                  </Grid>
                                </Grid>
                              </TabPanel>
                              <TabPanel value="3">
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Rural Farmers: {no_details?.rural_count?no_details?.rural_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Urban Farmers: {no_details?.urban_count?no_details?.urban_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Not Specified: {no_details?.no_town_count?no_details?.no_town_count:0}</b>  
                                      </Typography>

                                      <TownPieChart 
                                        rural={no_details?.rural_count?no_details?.rural_count:0} 
                                        urban={no_details?.urban_count?no_details?.urban_count:0} 
                                        not_specified={no_details?.no_town_count?no_details?.no_town_count:0}
                                      />
                                  </Grid>

                                  <Grid item xs={12} md={8}>
                                    <BarGuyTown 
                                      r_savings={no_details?.r_savings}
                                      u_savings={no_details?.u_savings}
                                      ntt_savings={no_details?.ntt_savings}
                                      r_loans={no_details?.r_loans}
                                      u_loans={no_details?.u_loans}
                                      ntt_loans={no_details?.ntt_loans}
                                      r_productionLoans={no_details?.r_productionLoans}
                                      u_productionLoans={no_details?.u_productionLoans}
                                      ntt_productionLoans={no_details?.ntt_productionLoans}
                                      r_equipmentLoans={no_details?.r_equipmentLoans}
                                      u_equipmentLoans={no_details?.u_equipmentLoans}
                                      ntt_equipmentLoans={no_details?.ntt_equipmentLoans}
                                      r_commodityLoans={no_details?.r_commodityLoans}
                                      u_commodityLoans={no_details?.u_commodityLoans}
                                      ntt_commodityLoans={no_details?.ntt_commodityLoans}
                                      r_shares={no_details?.r_shares}
                                      u_shares={no_details?.u_shares}
                                      ntt_shares={no_details?.ntt_shares}
                                    />
                                  </Grid>
                                </Grid>
                              </TabPanel>
                              <TabPanel value="4">
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Crops and total land sizes</b>  
                                    </Typography>
                                    <Divider variant='middle'/>
                                    {
                                      no_land_details?.pie_data.map((one) => (
                                        <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{one.Crop}: {one?.land_size} acres</b>  
                                        </Typography>
                                      ))
                                    }
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Total: {no_land_details?.total_land} acres</b>  
                                    </Typography>
                                  </Grid>
                                  
                                  <Grid item xs={12} md={8}>
                                      <LandDonuts 
                                        land_details={no_land_details}
                                      />
                                  </Grid>
                                </Grid>
                              </TabPanel>
                              <TabPanel value="5">
                                  <Grid item xs={12} md={12}>
                                    <AreaManProduction 
                                      land_details={no_land_details}
                                    />
                                  </Grid>
                              </TabPanel>
                            </TabContext>
                          </Grid>
                        </Grid>
                    </TabPanel>
                    
                    <TabPanel value='3'>
                    <Grid container spacing={2}>
                          <Grid item xs={12} md={12}>
                            <Box sx={{ display:'flex', flexDirection:'row' }}>
                              <Typography sx={{ marginRight:'auto' }} variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Farmers</b>  
                              </Typography>
                              <Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>Total: {members.farmers}</b>  
                              </Typography>
                            </Box>
                            <Divider variant='middle'/>
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <TabContext  value={value}>
                                <TabList onChange={handleChange} sx={{ 
                                      m: 'auto',
                                      display: 'flex',
                                      flexDirection: 'row',
                                      justifyContent: 'center',
                                      backgroundColor: '#ffffff',
                                      borderWidth: 2,
                                      borderRadius: 4,
                                      p: 0,
                                      maxWidth: '100%',
                                      alignItems: 'center',
                                    }} aria-label="lab API tabs example">
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Gender Ratio</b></Typography>} value="1" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Age Ratio</b></Typography>} value="2" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px',
                                      mr:'5px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Town Type</b></Typography>} value="3" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px',
                                      mr:'5px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Farm Lands</b></Typography>} value="4" />
                                  <Tab sx={{
                                      pt: 0,
                                      pb: 0,
                                      pr: 1, 
                                      pl: 1,
                                      backgroundColor: '#ffffff',
                                      borderRadius: 4,
                                      borderWidth:'2px',
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      m:'8px',
                                      mr:'5px'
                                    }} label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Production Data</b></Typography>} value="5" />
                                </TabList>
                                {/* Gender ratio */}
                              <TabPanel value="1">
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Males: {farmers_details?.males_count?farmers_details?.males_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Females: {farmers_details?.females_count?farmers_details?.females_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Not Specified: {farmers_details?.no_gender_count?farmers_details?.no_gender_count:0}</b>  
                                      </Typography>

                                      <AgePieChart 
                                        males={farmers_details?.males_count?farmers_details?.males_count:0} 
                                        females={farmers_details?.females_count?farmers_details?.females_count:0} 
                                        not_specified={farmers_details?.no_gender_count?farmers_details?.no_gender_count:0}
                                      />
                                  </Grid>

                                  <Grid item xs={12} md={8}>
                                    <BarGuy 
                                      m_savings={farmers_details?.m_savings}
                                      f_savings={farmers_details?.f_savings}
                                      n_savings={farmers_details?.n_savings}
                                      m_loans={farmers_details?.m_loans}
                                      f_loans={farmers_details?.f_loans}
                                      n_loans={farmers_details?.n_loans}
                                      m_productionLoans={farmers_details?.m_productionLoans}
                                      f_productionLoans={farmers_details?.f_productionLoans}
                                      n_productionLoans={farmers_details?.n_productionLoans}
                                      m_equipmentLoans={farmers_details?.m_equipmentLoans}
                                      f_equipmentLoans={farmers_details?.f_equipmentLoans}
                                      n_equipmentLoans={farmers_details?.n_equipmentLoans}
                                      m_commodityLoans={farmers_details?.m_commodityLoans}
                                      f_commodityLoans={farmers_details?.f_commodityLoans}
                                      n_commodityLoans={farmers_details?.n_commodityLoans}
                                      m_shares={farmers_details?.m_shares}
                                      f_shares={farmers_details?.f_shares}
                                      n_shares={farmers_details?.n_shares}
                                    />
                                  </Grid>

                                </Grid>
                                
                              </TabPanel>
                              <TabPanel value="2">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                      <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Youths (15 to 39): {farmers_details?.youth_count?farmers_details?.youth_count:0}</b>  
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Middle-Aged (40 to 60): {farmers_details?.middle_age_count?farmers_details?.middle_age_count:0}</b>  
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Old-Aged (60...): {farmers_details?.old_age_count?farmers_details?.old_age_count:0}</b>  
                                        </Typography>
                                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>Not Specified: {farmers_details?.no_age_count?farmers_details?.no_age_count:0}</b>  
                                        </Typography>

                                        <GenderPieChart 
                                          youths={farmers_details?.youth_count?farmers_details?.youth_count:0} 
                                          middle_aged={farmers_details?.middle_age_count?farmers_details?.middle_age_count:0} 
                                          old_aged={farmers_details?.old_age_count?farmers_details?.old_age_count:0} 
                                          not_specified={farmers_details?.no_age_count?farmers_details?.no_age_count:0}
                                        />
                                    </Grid>
                                  <Grid item xs={12} md={8}>
                                    <BarGuyAge 
                                      y_savings={farmers_details?.y_savings}
                                      ma_savings={farmers_details?.ma_savings}
                                      oa_savings={farmers_details?.oa_savings}
                                      na_savings={farmers_details?.na_savings}
                                      y_loans={farmers_details?.y_loans}
                                      ma_loans={farmers_details?.ma_loans}
                                      oa_loans={farmers_details?.oa_loans}
                                      na_loans={farmers_details?.na_loans}
                                      y_productionLoans={farmers_details?.y_productionLoans}
                                      ma_productionLoans={farmers_details?.ma_productionLoans}
                                      oa_productionLoans={farmers_details?.oa_productionLoans}
                                      na_productionLoans={farmers_details?.na_productionLoans}
                                      y_equipmentLoans={farmers_details?.y_equipmentLoans}
                                      ma_equipmentLoans={farmers_details?.ma_equipmentLoans}
                                      oa_equipmentLoans={farmers_details?.oa_equipmentLoans}
                                      na_equipmentLoans={farmers_details?.na_equipmentLoans}
                                      y_commodityLoans={farmers_details?.y_commodityLoans}
                                      ma_commodityLoans={farmers_details?.ma_commodityLoans}
                                      oa_commodityLoans={farmers_details?.oa_commodityLoans}
                                      na_commodityLoans={farmers_details?.na_commodityLoans}
                                      y_shares={farmers_details?.y_shares}
                                      ma_shares={farmers_details?.ma_shares}
                                      oa_shares={farmers_details?.oa_shares}
                                      na_shares={farmers_details?.na_shares}
                                    />
                                  </Grid>
                                </Grid>
                              </TabPanel>
                              <TabPanel value="3">
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Rural Farmers: {farmers_details?.rural_count?farmers_details?.rural_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Urban Farmers: {farmers_details?.urban_count?farmers_details?.urban_count:0}</b>  
                                      </Typography>
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        <b>Not Specified: {farmers_details?.no_town_count?farmers_details?.no_town_count:0}</b>  
                                      </Typography>

                                      <TownPieChart 
                                        rural={farmers_details?.rural_count?farmers_details?.rural_count:0} 
                                        urban={farmers_details?.urban_count?farmers_details?.urban_count:0} 
                                        not_specified={farmers_details?.no_town_count?farmers_details?.no_town_count:0}
                                      />
                                  </Grid>

                                  <Grid item xs={12} md={8}>
                                    <BarGuyTown 
                                      r_savings={farmers_details?.r_savings}
                                      u_savings={farmers_details?.u_savings}
                                      ntt_savings={farmers_details?.ntt_savings}
                                      r_loans={farmers_details?.r_loans}
                                      u_loans={farmers_details?.u_loans}
                                      ntt_loans={farmers_details?.ntt_loans}
                                      r_productionLoans={farmers_details?.r_productionLoans}
                                      u_productionLoans={farmers_details?.u_productionLoans}
                                      ntt_productionLoans={farmers_details?.ntt_productionLoans}
                                      r_equipmentLoans={farmers_details?.r_equipmentLoans}
                                      u_equipmentLoans={farmers_details?.u_equipmentLoans}
                                      ntt_equipmentLoans={farmers_details?.ntt_equipmentLoans}
                                      r_commodityLoans={farmers_details?.r_commodityLoans}
                                      u_commodityLoans={farmers_details?.u_commodityLoans}
                                      ntt_commodityLoans={farmers_details?.ntt_commodityLoans}
                                      r_shares={farmers_details?.r_shares}
                                      u_shares={farmers_details?.u_shares}
                                      ntt_shares={farmers_details?.ntt_shares}
                                    />
                                  </Grid>
                                </Grid>
                              </TabPanel>
                              <TabPanel value="4">
                                <Grid container spacing={2}>
                                  <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Crops and total land sizes</b>  
                                    </Typography>
                                    <Divider variant='middle'/>
                                    {
                                      land_details?.pie_data.map((one) => (
                                        <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          <b>{one.Crop}: {one?.land_size} acres</b>  
                                        </Typography>
                                      ))
                                    }
                                    <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      <b>Total: {land_details?.total_land} acres</b>  
                                    </Typography>
                                  </Grid>
                                  
                                  <Grid item xs={12} md={8}>
                                      <LandDonuts 
                                        land_details={land_details}
                                      />
                                  </Grid>
                                </Grid>
                              </TabPanel>
                              <TabPanel value="5">
                                  <Grid item xs={12} md={12}>
                                    <AreaManProduction 
                                      land_details={land_details}
                                    />
                                  </Grid>
                              </TabPanel>
                            </TabContext>
                          </Grid>
                        </Grid>
                    </TabPanel>

                  </TabContext>
                </Grid>
                </Grid>
              </Item>
            </Grid>

            <Grid item xs={12} md={12}  sx={{ mb:120 }}>
              <Item>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <Box sx={{ display:'flex', flexDirection:'row' }}>
                      <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Expenditure</b>  
                      </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} md={4} sx={{ display:'flex', flexDirection:'column' }}>
                  {
                    expense_account && expense_account.map((item) => (
                      <>
                        <Typography sx={{ marginRight:'auto' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                          <b>{item.account_name}: {item.current_balance?currencyFormat.format(item.current_balance):currencyFormat.format(0)}</b>  
                        </Typography>
                        <Divider variant='middle'/>
                      </>
                    ))
                  }
                </Grid>
                
                <Grid item xs={12} md={8}>
                  <BarGuyExpense 
                    expense_account={expense_account}
                  />
                </Grid>
                
                    
              </Grid>
              </Item>
            </Grid>
            
                                    
          </Grid>
          
        </Grid>
      )
    }else{
      return(
        <Box sx={{ m:'auto', mt:20, p:'auto' }}>
          <CircularProgress />
        </Box>
      )
    }
    
}